export default __webpack_public_path__ + "static/media/gallary5.3727d58a.jpg";